/* eslint-disable */
import type { TransactionReturnType } from "../types"
import type { Abi, Address } from "viem"
import type { Config } from "wagmi"

import { veTokenAbi } from "@/domains/abis"

import { simulatedTransaction } from "../simulated-transaction"

type IncreaseLockDurationProps = {
  account: Address
  chainId: number
  config: Config
  vestedAddress: Address
  tokenId: number
  secondsToExtend: number
}

export const increaseLockDuration = async ({
  account,
  chainId,
  config,
  vestedAddress,
  tokenId,
  secondsToExtend,
}: IncreaseLockDurationProps): Promise<TransactionReturnType> => {
  try {
    const result = await simulatedTransaction({
      config,
      simulateArgs: {
        abi: veTokenAbi as Abi,
        account,
        address: vestedAddress,
        args: [tokenId, secondsToExtend],
        chainId,
        functionName: "increase_unlock_time",
      },
    })
    return result
  } catch (error: any) {
    console.error("increaseLockDuration", error)
    return { success: false, error: error.message, code: error.code }
  }
}

/*
const increaseLockDuration = async ({ web3, tokenId, secondsToExtend, account, gasPrice, vestedAddress }) => {
  try {
    const options = { from: account }
    if (gasPrice) {
      options["gasPrice"] = gasPrice
    }
    const veTokenContract = new web3.eth.Contract(veTokenAbi, vestedAddress)
    const tx = await veTokenContract.methods.increase_unlock_time(tokenId, secondsToExtend).send(options)
    return { tx, success: true }
  } catch (error: any) {
    console.error("increaseLockDuration", error)
    // @ts-ignore
    return { tx: null, success: false, error: error.message, code: error.code }
  }
}
*/
